<template>
  <div class="hidden sm:flex relative overflow-hidden rounded-full py-1.5 px-4 text-sm leading-6 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
    <span class="text-gray-600">
      Open to corporate sponsorship. <router-link to="/sponsor/" class="font-semibold text-indigo-600"><span class="absolute inset-0" aria-hidden="true" />Read more <span aria-hidden="true">&rarr;</span></router-link>
    </span>
  </div>
</template>
